import { NgModule } from "@angular/core";
import { CoreModule } from "../../core/core.module";
import { CardModule } from "./card/card.module";
import { ChannelWorksLogoModule } from "./channelworks-logo/channelworks-logo.module";
import { CsvDownloadButtonModule } from "./csv-download-button/csv-download-button.module";
import { DataTableModule } from "./data-table/data-table.module";
import { DeleteModalModule } from "./delete-modal/delete-modal.module";
import { DemoDataModalModule } from "./demo-data-modal/demo-modal.module";
import { DynamicFormModule } from "./dynamic-form/dynamic-form.module";
import { ExportFileComponent } from "./export-file/export-file.component";
import { ExportFileModule } from "./export-file/export-file.module";
import { GenericInputModalModule } from "./generic-input-modal/generic-input-modal";
import { GenericModalComponent } from "./generic-modal/generic-modal.component";
import { GenericModalModule } from "./generic-modal/generic-modal.module";
import { MapBoxModule } from "./map-box/map-box.module";
import { NotificationsModule } from "./notification/notifications.module";
import { PaginatorModule } from "./paginator/paginator.module";
import { PieChartModule } from "./pie-chart/pie-chart.module";
import { PropertyListModule } from "./property-list/property-list.module";
import { QuickEditModalModule } from "./quick-edit-modal/quick-edit-modal.module";
import { QuickViewModalModule } from "./quick-view-modal/quick-view-modal.module";
import { SearchBarModule } from "./search-bar/search-bar.module";
import { SimpleDialogModule } from "./simple-dialog/simple-dialog.module";
import { TransferModule } from "./transfer/transfer.module";
import { ViewAsModule } from "./view-as/view-as.module";
@NgModule({
  declarations: [],
  imports: [
    CardModule,
    ChannelWorksLogoModule,
    CsvDownloadButtonModule,
    DeleteModalModule,
    DataTableModule,
    DynamicFormModule,
    GenericModalModule,
    QuickEditModalModule,
    QuickViewModalModule,
    SimpleDialogModule,
    ExportFileModule,
    MapBoxModule,
    NotificationsModule,
    PaginatorModule,
    PieChartModule,
    PropertyListModule,
    SearchBarModule,
    TransferModule,
    ViewAsModule,
    CoreModule,
    DemoDataModalModule,
    GenericInputModalModule,
  ],
  exports: [
    CardModule,
    ChannelWorksLogoModule,
    CsvDownloadButtonModule,
    DeleteModalModule,
    ExportFileComponent,
    GenericModalComponent,
    GenericModalModule,
    QuickEditModalModule,
    QuickViewModalModule,
    SimpleDialogModule,
    MapBoxModule,
    DataTableModule,
    DynamicFormModule,
    ExportFileModule,
    NotificationsModule,
    PaginatorModule,
    PieChartModule,
    PropertyListModule,
    TransferModule,
    ViewAsModule,
    DemoDataModalModule,
    GenericInputModalModule,
  ],
})
export class ComponentsModule {}
